import { collectionInHub } from './nativeHubModel.js'
import { useQueries } from '@tanstack/react-query'
import { nativeSportsbookApi } from '@/services/api'
import { normalizeRuntimePreviewCatalog } from './nativeRuntimeCatalog'
import { collectionPreviewFailure, resolveSampleCollection } from './collectionModel'
import { isLiveSource } from './catalogSources'

export function useCollectionPreviews(slug, components, source, catalog, persona = null, context = null, regulation = null) {
  const definitions = components.filter((component) => component.collection).map((component) => component.collection)
  const results = useQueries({ queries: definitions.map((definition) => ({
    queryKey: ['native-collection-preview', slug, source, definition, persona, context, regulation],
    enabled: Boolean(slug) && (definition.kind !== 'search' || definition.query?.trim().length >= 2),
    queryFn: async ({ signal }) => {
      const scoped = collectionInHub(definition, context)
      if (!scoped) return { state: 'unavailable', complete: false, events: [], choices: {} }
      if (source === 'sample') return resolveSampleCollection(scoped, catalog, new Date(), persona, regulation)
      const result = await nativeSportsbookApi.previewCollection(slug, scoped, signal, persona, regulation, source)
      return { ...result, events: normalizeRuntimePreviewCatalog({ ...result, freshness: result.state === 'cached' ? 'stale' : 'replicated' }).events }
    }, staleTime: 5000, refetchInterval: isLiveSource(source) ? 15000 : false, retry: false,
  })) })
  return Object.fromEntries(definitions.map((definition, index) => {
    const query = results[index]
    const result = query.isError ? collectionPreviewFailure(definition, query.data) : query.data
    return [definition.id, { ...(result || { events: [], choices: {} }), refresh: query.refetch, refreshing: query.isFetching }]
  }))
}
